export default __webpack_public_path__ + "static/media/card-powered-by-stripe.5c7c44be.svg";